import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import * as Action from "../../store/redux/admin_reducer.js";
import "./adminProfile.css";

// Components
import AccountCompAdmin from "./admin_profile_comps/AccountCompAdmin.jsx";
import { PassportUpload } from "./admin_profile_comps/AdminFileUpload.jsx";
import Busery from "./admin_profile_comps/Busery.jsx";
import AdmitApplicants from "./admin_profile_comps/Admit_Applicants";
import ApplicantLogs from "./admin_profile_comps/ApplicantsLogs";
import FormSales from "./admin_profile_comps/FormSales";
import Acceptance from "./admin_profile_comps/Acceptance";
import GeneralReport from "./admin_profile_comps/GeneralReport";
import Students from "./admin_profile_comps/Students";
import StaffEmployement from "./admin_profile_comps/StaffEmployment.jsx";
import Administration from "./admin_profile_comps/Administration.jsx";
import MconsStaff from "./admin_profile_comps/MconsStaff.jsx";
import Inboxes from "./admin_profile_comps/Inboxes.jsx";
import MidwiferyProgramme from "./admin_profile_comps/MidwiferyProgramme.jsx";
import NursingProgramme from "./admin_profile_comps/NursingProgramme.jsx";
import GSTProgramme from "./admin_profile_comps/GSTProgramme.jsx";
import Hostels from "./admin_profile_comps/Hostels.jsx";
import BuseryServices, {
  FullPaymentComp,
} from "./admin_profile_comps/BuseryServices.jsx";
import QRScanQRCodeScanning from "./admin_profile_comps/QRCodeScanning.jsx";
import ResultUpload from "./admin_profile_comps/ResultUpload.jsx";
import ResultEdit from "./admin_profile_comps/ResultEdit.jsx";

// Logo / custom icons
import Logo from "../public_directory/public-routes-images/logos/Manga_Cons _Logo3.png";
import Icons from "./icons/mms.png";

// MUI Icons
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import SchoolIcon from "@mui/icons-material/School";
import MailIcon from "@mui/icons-material/Mail";
import ApprovalIcon from "@mui/icons-material/Approval";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import LockResetIcon from "@mui/icons-material/LockReset";
import BalanceIcon from "@mui/icons-material/Balance";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import SavingsIcon from "@mui/icons-material/Savings";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import BabyChangingStationIcon from "@mui/icons-material/BabyChangingStation";
import VaccinesIcon from "@mui/icons-material/Vaccines";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import IsoIcon from "@mui/icons-material/Iso";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";

export default function AdminProfile() {
  const dispatch = useDispatch();

  // ---------------------------------------------------------------------------
  // REDUX
  // ---------------------------------------------------------------------------
  const data = useSelector(
    (state) => state.adminFunction.queue.adminData
  );

  const active = useSelector(
    (state) => state.adminFunction.dashboard?.nav_trace
  );

  // ---------------------------------------------------------------------------
  // LOCAL STATE
  // ---------------------------------------------------------------------------
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [expandedSection, setExpandedSection] = useState(null);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  // ---------------------------------------------------------------------------
  // NAVIGATION CONFIGURATION
  // ---------------------------------------------------------------------------
  const NAVIGATION = useMemo(
    () => [
      {
        id: "administration",
        label: "Administration",
        description: "Institution operations",
        icon: <AdminPanelSettingsIcon />,
        color: "blue",
        children: [
          {
            id: "administrative",
            label: "Administration",
            description: "Institution controls",
            icon: <AdminPanelSettingsIcon />,
          },
          {
            id: "staff",
            label: "MCONS Staff",
            description: "Staff management",
            icon: <Diversity3Icon />,
          },
          {
            id: "employement",
            label: "Employment",
            description: "Employment records",
            icon: <WorkHistoryIcon />,
          },
          {
            id: "inbox",
            label: "Inbox Messages",
            description: "Communication center",
            icon: <MailIcon />,
            badge: 0,
          },
        ],
      },
      {
        id: "student",
        label: "Students",
        description: "Student lifecycle",
        icon: <SchoolIcon />,
        color: "purple",
        children: [
          {
            id: "student",
            label: "Students",
            description: "Student directory",
            icon: <CastForEducationIcon />,
          },
          {
            id: "add and drop",
            label: "Add / Drop Courses",
            description: "Course registration",
            icon: <IsoIcon />,
          },
          {
            id: "result upload",
            label: "Result Upload",
            description: "Upload student results",
            icon: <CloudUploadIcon />,
          },
          {
            id: "result edit",
            label: "Result Editing",
            description: "Edit submitted results",
            icon: <AssessmentOutlinedIcon />,
          },
          {
            id: "qr scanning",
            label: "QR Scan",
            description: "Scan student QR codes",
            icon: <LockResetIcon />,
          },
        ],
      },
      {
        id: "programmes",
        label: "Programmes",
        description: "Academic programmes",
        icon: <SchoolOutlinedIcon />,
        color: "orange",
        children: [
          {
            id: "nursing",
            label: "General Nursing",
            description: "Nursing programme",
            icon: <VaccinesIcon />,
          },
          {
            id: "midwifery",
            label: "Midwifery",
            description: "Midwifery programme",
            icon: <BabyChangingStationIcon />,
          },
          {
            id: "gst",
            label: "General Studies",
            description: "GST programme",
            icon: <HistoryEduIcon />,
          },
        ],
      },
      {
        id: "bursary",
        label: "Bursary",
        description: "Finance & payments",
        icon: <AssuredWorkloadIcon />,
        color: "green",
        children: [
          {
            id: "tuition",
            label: "Tuitions",
            description: "Tuition management",
            icon: <RequestQuoteIcon />,
          },
          {
            id: "hostel",
            label: "Hostel Allocation",
            description: "Manage hostel allocation",
            icon: <CurrencyExchangeIcon />,
          },
          {
            id: "form sales",
            label: "Form Sales",
            description: "Application form sales",
            icon: <PriceCheckIcon />,
          },
          {
            id: "services",
            label: "Services",
            description: "Financial services",
            icon: <SavingsIcon />,
          },
        ],
      },
      {
        id: "admissions",
        label: "Admissions",
        description: "Applicant management",
        icon: <ApprovalIcon />,
        color: "indigo",
        children: [
          {
            id: "app_logs",
            label: "Application Logs",
            description: "Application activity",
            icon: <HistoryEduIcon />,
          },
          {
            id: "admit_applicant",
            label: "Admit Applicant",
            description: "Review applicants",
            icon: <ApprovalIcon />,
          },
          {
            id: "form_sum",
            label: "Form Sales",
            description: "Admission form sales",
            icon: <PriceCheckIcon />,
          },
          {
            id: "accept_reg",
            label: "Acceptance Reports",
            description: "Acceptance responses",
            icon: <AssuredWorkloadIcon />,
          },
          {
            id: "reports",
            label: "General Reports",
            description: "Admission analytics",
            icon: <BalanceIcon />,
          },
        ],
      },
    ],
    []
  );

  // ---------------------------------------------------------------------------
  // ACTIVE NAVIGATION
  // ---------------------------------------------------------------------------
  const activeNavigation = useMemo(() => {
    for (const section of NAVIGATION) {
      const child = section.children?.find(
        (item) => item.id === active
      );

      if (child) {
        return {
          section,
          child,
        };
      }
    }

    return null;
  }, [NAVIGATION, active]);

  // ---------------------------------------------------------------------------
  // AUTOMATICALLY OPEN ACTIVE SECTION
  // ---------------------------------------------------------------------------
  useEffect(() => {
    if (activeNavigation?.section?.id) {
      setExpandedSection(activeNavigation.section.id);
    }
  }, [activeNavigation]);

  // ---------------------------------------------------------------------------
  // ACTIVE TITLES
  // ---------------------------------------------------------------------------
  function getActiveTitle() {
    if (activeNavigation?.child?.label) {
      return activeNavigation.child.label;
    }

    if (active === "account") {
      return "Account";
    }

    if (active === "setting") {
      return "Settings";
    }

    return "Administration";
  }

  function getActiveSectionTitle() {
    return activeNavigation?.section?.label || "Workspace";
  }

  // ---------------------------------------------------------------------------
  // NAVIGATION
  // ---------------------------------------------------------------------------
  function handleNavigator(item) {
    dispatch(Action.dispathcDashboardNavigator({ item }));
    setMobileSidebarOpen(false);
  }

  function toggleNavigationSection(section) {
    if (sidebarCollapsed) {
      setSidebarCollapsed(false);
      setExpandedSection(section);
      return;
    }

    setExpandedSection((current) =>
      current === section ? null : section
    );
  }

  // ---------------------------------------------------------------------------
  // LOGOUT
  // ---------------------------------------------------------------------------
  function logout() {
    dispatch(Action.logOut());
  }

  // ---------------------------------------------------------------------------
  // MODAL
  // ---------------------------------------------------------------------------
  function closeModalDiv() {
    setOpenModal(false);
    setShowModal("");
  }

  function toggleModalBoxContents() {
    switch (showModal) {
      case "services full payment":
        return <FullPaymentComp />;
      default:
        return null;
    }
  }

  // ---------------------------------------------------------------------------
  // COMPONENT SWITCHER
  // ---------------------------------------------------------------------------
  function switchComponents() {
    switch (active) {
      case "account":
        return <AccountCompAdmin setLoading={setLoading} />;

      case "administrative":
        return <Administration setLoading={setLoading} />;

      case "staff":
        return <MconsStaff setLoading={setLoading} />;

      case "admit_applicant":
        return <AdmitApplicants setLoading={setLoading} />;

      case "app_logs":
        return <ApplicantLogs setLoading={setLoading} />;

      case "form_sum":
        return <FormSales setLoading={setLoading} />;

      case "form sales":
        return <FormSales setLoading={setLoading} />;

      case "accept_reg":
        return <Acceptance setLoading={setLoading} />;

      case "reports":
        return <GeneralReport setLoading={setLoading} />;

      case "student":
        return <Students setLoading={setLoading} />;

      case "midwifery":
        return <MidwiferyProgramme setLoading={setLoading} />;

      case "nursing":
        return <NursingProgramme setLoading={setLoading} />;

      case "gst":
        return <GSTProgramme setLoading={setLoading} />;

      case "setting":
        return <AccountCompAdmin setLoading={setLoading} />;

      case "add and drop":
        return (
          <div className="admin-coming-soon">
            <div className="admin-coming-soon-icon">
              <IsoIcon />
            </div>

            <div>
              <h2>Adding and dropping courses</h2>
              <p>
                Course add/drop management is currently being
                prepared for this workspace.
              </p>
            </div>
          </div>
        );

      case "inbox":
        return <Inboxes setLoading={setLoading} />;

      case "result upload":
        return <ResultUpload setLoading={setLoading} />;

      case "result edit":
        return <ResultEdit setLoading={setLoading} />;

      case "tuition":
        return <Busery setLoading={setLoading} />;

      case "busery":
        return <Busery setLoading={setLoading} />;

      case "employement":
        return <StaffEmployement setLoading={setLoading} />;

      case "hostel":
        return <Hostels setLoading={setLoading} />;

      case "services":
        return (
          <BuseryServices
            setOpenModal={setOpenModal}
            setShowModal={setShowModal}
            setLoading={setLoading}
            info={data}
          />
        );

      case "qr scanning":
        return <QRScanQRCodeScanning />;

      default:
        return <AccountCompAdmin setLoading={setLoading} />;
    }
  }

  // ---------------------------------------------------------------------------
  // SEARCH
  // ---------------------------------------------------------------------------
  const filteredNavigation = useMemo(() => {
    const search = searchValue.trim().toLowerCase();

    if (!search) {
      return NAVIGATION;
    }

    return NAVIGATION.map((section) => {
      const sectionMatches =
        section.label.toLowerCase().includes(search) ||
        section.description.toLowerCase().includes(search);

      const matchingChildren = section.children.filter(
        (child) =>
          child.label.toLowerCase().includes(search) ||
          child.description.toLowerCase().includes(search)
      );

      if (sectionMatches) {
        return section;
      }

      if (matchingChildren.length) {
        return {
          ...section,
          children: matchingChildren,
        };
      }

      return null;
    }).filter(Boolean);
  }, [NAVIGATION, searchValue]);

  // ---------------------------------------------------------------------------
  // SIDEBAR SECTION
  // ---------------------------------------------------------------------------
  function SidebarSection({ section }) {
    const isExpanded = expandedSection === section.id;

    const hasActiveChild = section.children?.some(
      (child) => child.id === active
    );

    const childCount = section.children?.length || 0;

    return (
      <section
        className={`saas-nav-section ${
          hasActiveChild ? "has-active-child" : ""
        }`}
      >
        <button
          type="button"
          className={`saas-nav-parent ${
            isExpanded ? "expanded" : ""
          } ${hasActiveChild ? "section-active" : ""}`}
          onClick={() => toggleNavigationSection(section.id)}
          title={sidebarCollapsed ? section.label : undefined}
        >
          <span className="saas-nav-parent-left">
            <span
              className={`saas-nav-icon saas-nav-icon-${section.color}`}
            >
              {section.icon}
            </span>

            {!sidebarCollapsed && (
              <span className="saas-nav-parent-copy">
                <span className="saas-nav-parent-title-row">
                  <strong>{section.label}</strong>

                  <span className="saas-nav-count">
                    {childCount}
                  </span>
                </span>

                <small>{section.description}</small>
              </span>
            )}
          </span>

          {!sidebarCollapsed && (
            <ExpandMoreIcon
              className={`saas-nav-expand-icon ${
                isExpanded ? "rotate" : ""
              }`}
            />
          )}
        </button>

        {!sidebarCollapsed && (
          <div
            className={`saas-nav-children ${
              isExpanded ? "children-open" : ""
            }`}
          >
            {section.children?.map((child) => {
              const isActive = active === child.id;

              return (
                <button
                  type="button"
                  key={child.id}
                  className={`saas-nav-child ${
                    isActive ? "child-active" : ""
                  }`}
                  onClick={() => handleNavigator(child.id)}
                >
                  <span className="child-rail">
                    {isActive && <span />}
                  </span>

                  <span className="child-icon">
                    {child.icon}
                  </span>

                  <span className="child-copy">
                    <span className="child-label">
                      {child.label}
                    </span>

                    <span className="child-description">
                      {child.description}
                    </span>
                  </span>

                  {child.badge !== undefined && (
                    <span className="child-badge">
                      {child.badge}
                    </span>
                  )}

                  {isActive && (
                    <span className="child-active-indicator">
                      <ChevronRightIcon />
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        )}
      </section>
    );
  }

  // ---------------------------------------------------------------------------
  // SYSTEM NAVIGATION
  // ---------------------------------------------------------------------------
  function SystemNavigation() {
    const systemItems = [
      {
        id: "account",
        label: "Account",
        description: "Profile & security",
        icon: <AccountCircleIcon />,
      },
      {
        id: "setting",
        label: "Settings",
        description: "Workspace configuration",
        icon: <SettingsOutlinedIcon />,
      },
    ];

    return (
      <div className="saas-system-navigation">
        {!sidebarCollapsed && (
          <div className="saas-nav-label">
            <span>SETTINGS</span>
          </div>
        )}

        {systemItems.map((item) => {
          const isActive = active === item.id;

          return (
            <button
              key={item.id}
              type="button"
              className={`saas-system-item ${
                isActive ? "system-active" : ""
              }`}
              onClick={() => handleNavigator(item.id)}
              title={sidebarCollapsed ? item.label : undefined}
            >
              <span className="system-item-icon">
                {item.icon}
              </span>

              {!sidebarCollapsed && (
                <span className="system-item-copy">
                  <strong>{item.label}</strong>
                  <small>{item.description}</small>
                </span>
              )}

              {!sidebarCollapsed && (
                <ChevronRightIcon className="system-item-arrow" />
              )}
            </button>
          );
        })}
      </div>
    );
  }

  // ---------------------------------------------------------------------------
  // SIDEBAR
  // ---------------------------------------------------------------------------
  function Sidebar() {
    return (
      <>
        {mobileSidebarOpen && (
          <div
            className="saas-mobile-overlay"
            onClick={() => setMobileSidebarOpen(false)}
          />
        )}

        <aside
          className={`
            saas-sidebar
            ${sidebarCollapsed ? "sidebar-collapsed" : ""}
            ${mobileSidebarOpen ? "mobile-sidebar-open" : ""}
          `}
        >
          {/* BRAND */}
          {/* <div className="saas-brand">
            <div className="saas-brand-logo">
              <img src={Logo} alt="Manga Cons" />
            </div>

            {!sidebarCollapsed && (
              <div className="saas-brand-copy">
                <strong>MANGA CONS</strong>
                <span>ADMIN PORTAL</span>
              </div>
            )}

            <button
              type="button"
              className="mobile-sidebar-close"
              onClick={() => setMobileSidebarOpen(false)}
              aria-label="Close navigation"
            >
              <CloseIcon />
            </button>
          </div> */}

          {/* WORKSPACE SWITCHER */}
          {!sidebarCollapsed ? (
            <button
              type="button"
              className="saas-workspace-card"
              title="Current workspace"
            >
              <div className="saas-workspace-avatar">
                {data?.first_Name?.charAt(0)?.toUpperCase() || "A"}
              </div>

              <div className="saas-workspace-info">
                <span>ACTIVE WORKSPACE</span>
                <strong>Administration</strong>
              </div>

              <span className="saas-workspace-status">
                <FiberManualRecordIcon />
              </span>

              <ExpandMoreIcon className="workspace-chevron" />
            </button>
          ) : (
            <div
              className="saas-collapsed-workspace"
              title="Administration workspace"
            >
              <span>
                {data?.first_Name?.charAt(0)?.toUpperCase() || "A"}
              </span>
              <i />
            </div>
          )}

          {/* SEARCH */}
          {!sidebarCollapsed && (
            <div className="saas-sidebar-search">
              <SearchIcon />

              <input
                type="text"
                value={searchValue}
                onChange={(event) =>
                  setSearchValue(event.target.value)
                }
                placeholder="Search navigation..."
                aria-label="Search navigation"
              />

              {searchValue && (
                <button
                  type="button"
                  onClick={() => setSearchValue("")}
                  aria-label="Clear search"
                >
                  <CloseIcon />
                </button>
              )}

              {!searchValue && (
                <span className="search-shortcut">⌘ K</span>
              )}
            </div>
          )}

          {/* NAVIGATION */}
          <div className="saas-sidebar-scroll">
            {!sidebarCollapsed && (
              <div className="saas-nav-label saas-nav-label-main">
                <span>WORKSPACE</span>
                <span className="nav-label-line" />
              </div>
            )}

            <nav className="saas-sidebar-navigation">
              {filteredNavigation.length ? (
                filteredNavigation.map((section) => (
                  <SidebarSection
                    key={section.id}
                    section={section}
                  />
                ))
              ) : (
                <div className="saas-nav-empty">
                  <SearchIcon />
                  <strong>No navigation found</strong>
                  <span>
                    Try searching for another workspace feature.
                  </span>
                </div>
              )}
            </nav>

            <SystemNavigation />

            {/* QUICK ACCESS */}
            {!sidebarCollapsed && (
              <div className="saas-sidebar-quick-links">
                <div className="saas-nav-label">
                  <span>QUICK ACCESS</span>
                </div>

                <Link
                  to={`/admin/${data?._id}/candidate/register_new_applicant`}
                  target="_blank"
                  className="saas-quick-link"
                >
                  <span className="quick-link-icon">
                    <img src={Icons} alt="" />
                  </span>

                  <span className="quick-link-copy">
                    <strong>New Applicant</strong>
                    <small>Register applicant</small>
                  </span>

                  <ArrowForwardRoundedIcon />
                </Link>
              </div>
            )}
          </div>

          {/* FOOTER */}
          <div className="saas-sidebar-footer">
            {!sidebarCollapsed ? (
              <>
                <div className="saas-admin-profile">
                  <div className="saas-admin-profile-avatar">
                    {data?.profileImage?.url ? (
                      <img
                        src={data.profileImage.url}
                        alt="Administrator"
                      />
                    ) : (
                      data?.first_Name?.charAt(0)?.toUpperCase() ||
                      "A"
                    )}
                  </div>

                  <div className="saas-admin-profile-copy">
                    <strong>
                      {data?.first_Name || "Administrator"}
                    </strong>

                    <span>Administrator</span>
                  </div>

                  <button
                    type="button"
                    className="saas-profile-more"
                    title="Account options"
                  >
                    <MoreHorizIcon />
                  </button>
                </div>

                <button
                  type="button"
                  className="saas-logout"
                  onClick={logout}
                >
                  <LogoutOutlinedIcon />
                  <span>Sign out</span>
                </button>
              </>
            ) : (
              <button
                type="button"
                className="saas-collapsed-logout"
                onClick={logout}
                title="Sign out"
              >
                <LogoutOutlinedIcon />
              </button>
            )}
          </div>
        </aside>
      </>
    );
  }

  // ---------------------------------------------------------------------------
  // TOPBAR
  // ---------------------------------------------------------------------------
  function Topbar() {
    return (
      <header className="saas-topbar">
        <div className="saas-topbar-left">
          <button
            type="button"
            className="saas-mobile-menu"
            onClick={() => setMobileSidebarOpen(true)}
            aria-label="Open navigation"
          >
            <MenuIcon />
          </button>

          <button
            type="button"
            className="saas-sidebar-toggle"
            onClick={() =>
              setSidebarCollapsed((current) => !current)
            }
            title={
              sidebarCollapsed
                ? "Expand sidebar"
                : "Collapse sidebar"
            }
          >
            {sidebarCollapsed ? (
              <MenuOpenIcon />
            ) : (
              <MenuIcon />
            )}
          </button>

          <div className="saas-breadcrumb">
            <span>Workspace</span>
            <ChevronRightIcon />
            <span>{getActiveSectionTitle()}</span>
            <ChevronRightIcon />
            <strong>{getActiveTitle()}</strong>
          </div>
        </div>

        <div className="saas-topbar-actions">
          <button
            type="button"
            className="saas-help-button"
            title="Help & support"
          >
            <HelpOutlineIcon />
            <span>Help</span>
          </button>

          <button
            type="button"
            className="saas-notification-button"
            title="Notifications"
          >
            <NotificationsActiveOutlinedIcon />
            <span className="notification-badge">0</span>
          </button>

          <div className="saas-topbar-profile">
            <div className="saas-topbar-avatar">
              {data?.profileImage?.url ? (
                <img
                  src={data.profileImage.url}
                  alt="Profile"
                />
              ) : (
                data?.first_Name?.charAt(0)?.toUpperCase() || "A"
              )}
            </div>

            <div className="saas-topbar-profile-copy">
              <strong>
                {data?.first_Name || "Administrator"}
              </strong>

              <span>Administrator</span>
            </div>

            <ExpandMoreIcon />
          </div>
        </div>
      </header>
    );
  }

  // ---------------------------------------------------------------------------
  // ACTIVATION CARD
  // ---------------------------------------------------------------------------
  function ActivationCard() {
    return (
      <div className="saas-activation-card">
        <div className="activation-card-main">
          <div className="activation-icon">
            <CloudUploadIcon />
          </div>

          <div className="activation-copy">
            <span className="activation-eyebrow">
              ACCOUNT VERIFICATION
            </span>

            <h2>Complete your account activation</h2>

            <p>
              Your administrator account is currently inactive.
              Upload your passport to verify and activate your
              account.
            </p>
          </div>
        </div>

        <div className="activation-action">
          <PassportUpload objectId={data?._id} />
        </div>
      </div>
    );
  }

  // ---------------------------------------------------------------------------
  // MAIN RENDER
  // ---------------------------------------------------------------------------
  return (
    <section className="admin-saas-shell">
      {/* MODAL */}
      {openModal && (
        <div
          className="saas-modal-backdrop"
          onClick={closeModalDiv}
        >
          <div
            className="saas-modal-wrapper"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="saas-modal-close"
              onClick={closeModalDiv}
            >
              <CloseIcon />
            </button>

            {toggleModalBoxContents()}
          </div>
        </div>
      )}

      {/* SIDEBAR */}
      <Sidebar />

      {/* APPLICATION */}
      <div className="saas-main">
        <Topbar />

        <main className="saas-content">
          {data?.account_status === "In-active" ? (
            <ActivationCard />
          ) : (
            <div className="saas-content-body">
              {loading && (
                <div className="saas-loading-bar">
                  <span />
                </div>
              )}

              <div className="saas-page-container">
                {switchComponents()}
              </div>
            </div>
          )}
        </main>
      </div>
    </section>
  );
}